//src/design-system/Organisms/MyVideosSection/VideosList.tsx
import { useState } from "react";
import type { FC } from "react";
import { VideosAccordionItem } from "./VideosAccordionItem";
import type { WatchedVideo } from "@/rtkQuery/features/models/video.model";

interface VideosListProps {
  data: WatchedVideo[];
}

export const VideosList: FC<VideosListProps> = ({ data }) => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const handleToggle = (index: number) => {
    setOpenIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  return (
    <div className="">
      {data && data?.map((item, index) => (
        <VideosAccordionItem
          key={index}
          video={item}
          isOpen={openIndex === index}
          onToggle={() => handleToggle(index)}
        />
      ))}
    </div>
  );
}; 